export default [
    {
        path: '/rest/campaign/:id/:type',
        name: 'legacy.campaign.save'
    }
]